import React from 'react';
import { useQuery } from 'react-query';
import { api } from "../../../api";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { extractCenterId } from "../../../utils/center";
import DeliverooSiteStatusData from "./DeliverooSiteStatusData";

// Pendant de StoreStatusIndicator (Uber Eats) : un bloc par magasin
// Deliveroo du centre (Frichti, La Belle Vie… peuvent partager un hub).
const DeliverooSiteStatusIndicator = ({ centerId }) => {
  const { isError, data, error, refetch } = useQuery(
    ['deliverooSiteStatuses', centerId],
    (_key, id) => api.retrieveDeliverooSiteStatus(id),
    {
      enabled: !!centerId,
      refetchInterval: 5 * 60000, // 5 mins
      retry: 5,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    });

  if (!data || !data.site_statuses || data.site_statuses.length === 0) {
    return null;
  }

  return (
    <>
      {data.site_statuses
        .filter(siteStatusData => siteStatusData.live)
        .map(siteStatusData => (
          <DeliverooSiteStatusData key={siteStatusData.site_id} siteStatusData={siteStatusData} centerId={centerId} refetch={refetch} />
        ))}
      {isError && <div>{error.message}</div>}
    </>
  );
};

DeliverooSiteStatusIndicator.propTypes = {
  centerId: PropTypes.number,
};

export const ConnectedDeliverooSiteStatusIndicator = connect(
  (state) => ({
    centerId: extractCenterId(state.user),
  })
)(DeliverooSiteStatusIndicator);

export default ConnectedDeliverooSiteStatusIndicator;
